import type { RouteLocationResolvedGeneric } from "vue-router"

interface Crumb {
  text?: string
  to?: string
  title?: string
}

export const dataBreadcrumbAdjustments = reactive<Record<string, Crumb>>({
  // Adjustments for the breadcrumbs
})

// Saves the adjustment into getBreadcrumbAdjustments by page.title so that it may be read later
export const adjustPageBreadcrumbs = (
  adjustment: {[key: string]: string},
  page: RouteLocationResolvedGeneric|null = null
) => {
  if (!page) {
    return false;
  }

  if (page.name) {
    dataBreadcrumbAdjustments[page.name as string] = adjustment as Crumb
  } else {
    console.warn(`No breadcrumbs adjustments for ${page.path}`)
  }
}

export const getBreadcrumbAdjustment = (page: RouteLocationResolvedGeneric|null = null) => {
  if(!page) return {}

  if (page.name) {
    const name = page.name as string
    if (name in dataBreadcrumbAdjustments) {
      return dataBreadcrumbAdjustments[name]
    } else {
      console.warn(`No breadcrumbs adjustments for ${name}`)
    }
  }
}

export const getPage = () : RouteLocationResolvedGeneric => {
  return useRouter().resolve(useRouter().currentRoute.value.path)
}

export const getPageFromTitle = (title: string) : RouteLocationResolvedGeneric|false => {
  const pages = useRouter().getRoutes()
  const page = pages.find((page) => {
    return page.meta.title === title
  })

  if (page) {
    return useRouter().resolve(page.path)
  } else {
    return false
  }
}

export const getPageName = (page: RouteLocationResolvedGeneric) => {
  const resolved = page ?? getPage()

  let name: any = (resolved.name as string)
    .split('__')[0]
    .split('-')

  // name is last item of list
  name = name[name.length - 1]

  // split name by capital letters
  name = name.replace(/([A-Z])/g, ' $1')

  // Remove whitespaces
  name = name.trim()

  // replace first letter with uppercase
  name = name.charAt(0).toUpperCase() + name.slice(1)

  return {
    text: name,
    to: resolved.path,
    titel: resolved.name
  }
}
